<template>
    <div
        class="animate-spin before:absolute before:block before:h-full before:w-full before:rounded-full before:border-opacity-30 after:absolute after:block after:h-full after:w-full after:rounded-full after:border-transparent"
        :class="[colorClassName, widthClassName]"
    />
</template>

<script lang="ts"></script>

<script setup lang="ts">
    import { computed } from 'vue';
    import { SpinnerWidth } from '@/components/activix-ui/ActivixSpinner/types.ts';

    interface Props {
        light?: boolean;
        width?: SpinnerWidth;
        disableDefaultColors?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        light: false,
        width: SpinnerWidth.Thin,
        disableDefaultColors: false,
    });

    const colorClassName = computed(() => {
        if (props.disableDefaultColors) {
            return '';
        }

        return props.light
            ? 'before:border-white after:border-t-white'
            : 'before:border-gray-600 after:border-t-gray-600';
    });

    const widthClassName = computed(() => {
        const widthClasses: Record<SpinnerWidth, string> = {
            [SpinnerWidth.Thin]: 'before:border-2 after:border-2',
            [SpinnerWidth.Medium]: 'before:border-3 after:border-3',
            [SpinnerWidth.Thick]: 'before:border-4 after:border-4',
        };
        return widthClasses[props.width];
    });
</script>
